import axios from 'axios';

const instance = axios.create({
  baseURL: 'https://burger-builder-a7529-default-rtdb.firebaseio.com/'
});

export default instance;


// WEBPACK FOOTER //
// ./src/axios-orders.js